import jQuery from 'jquery';

jQuery(($) => {
  'use strict';

  let navbar = $('#NavBar');

  if (navbar.length > 0) {
    navbar.find('> li').hover((evt) => {
      $(evt.target).find('ul').removeClass('noJS').stop(true, true).slideToggle('medium');
    });
  }
});